import React from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons/core-free-icons";
import { Container, Disc, Body, Title, Text, Reason } from "./style";

interface BoxProps {
  children?: React.ReactNode;
  title: React.ReactNode;
  text: string;
  /** A HugeIcons definition. It used to be the src of an SVG file. */
  icon: any;
  fixedSize?: boolean;
  disabled?: boolean;
  /** What would make a disabled choice available. Shown in place of nothing. */
  reason?: string;
  onClick?: () => void;
}

export const Box = ({
  icon,
  title,
  text,
  children,
  fixedSize = true,
  disabled = false,
  reason,
  ...rest
}: BoxProps) => {
  return (
    <Container
      type="button"
      $fixedSize={fixedSize}
      disabled={disabled}
      {...rest}
    >
      <Disc>
        <HugeiconsIcon icon={icon} size={20} strokeWidth={1.7} />
      </Disc>
      <Body>
        <Title>{title}</Title>
        <Text>{text}</Text>
        {disabled && reason && (
          <Reason>
            <HugeiconsIcon icon={AlertCircleIcon} size={13} strokeWidth={1.9} />
            {reason}
          </Reason>
        )}
        {children}
      </Body>
    </Container>
  );
};
